export const webEmbedTab = {
  scope: {
    title: "Was soll Ihre Website durchsuchen?",
    only: "Nur",
    thisListing: "dieses Inserat",
    hint: "Empfohlen, wenn Sie den Code auf der Seite dieser Unterkunft einfügen. Deaktivieren Sie die Option, damit die Suche alle Ihre Unterkünfte anzeigt.",
  },
  where: {
    title: "Wo sollen die Unterkünfte erscheinen?",
    hint: 'Die Suchleiste sieht in allen drei Fällen gleich aus. Unterschiedlich ist nur, was passiert, wenn der Besucher auf "Suchen" tippt.',
    ariaLabel: "Wo die Verfügbarkeit erscheint",
    ownFields: {
      name: "Ich habe bereits eine eigene Suchleiste",
      hint: "Wir fügen keine Leiste hinzu: Verwenden Sie Ihre eigenen Felder und übergeben Sie uns die Suche",
    },
  },
  modes: {
    overlay: {
      name: "Schwebend über Ihrer Website",
      tag: "Empfohlen",
      desc: "Die Liste öffnet sich in einem Fenster über Ihrer Seite und wird mit dem X geschlossen. Ihre Website bewegt sich nicht: Der Besucher kehrt genau dorthin zurück, wo er war.",
    },
    inline: {
      name: "Innerhalb Ihrer Seite",
      desc: "Die Liste erscheint auf Ihrer eigenen Website wie ein weiterer Abschnitt: Sie scrollt mit dem übrigen Inhalt und es gibt nichts zu schließen. Sie bestimmen, wo auf der Seite sie erscheint.",
    },
    tab: {
      name: "In einem neuen Tab",
      desc: "Die Leiste liegt auf Ihrer Website und bei der Suche geht die Buchung in einem anderen Tab weiter. Das ist die einfachste Option, aber der Besucher schließt die Buchung woanders ab.",
    },
  },
  modeNote: {
    overlay: "Die Suchleiste behält eine feste Höhe und verändert sich nicht: Die Liste und der gesamte Buchungsprozess laufen im schwebenden Fenster mit eigenem Scroll.",
    inline: "Hier wächst nur der Listenbereich, also genau das, was wachsen soll. Die Suchleiste nimmt weiterhin denselben Platz ein und der Kalender öffnet sich darüber, ohne etwas zu verschieben.",
    tab: "Nur die Leiste wird eingebettet. Alles andere läuft in der Buchungsmaschine in einem separaten Tab.",
  },
  webs: {
    bahia: "Website mit Hero",
    cala: "Minimalistische Website",
  },
  fondos: {
    white: "Weiß (Standard)",
    transparent: "Transparent · übernimmt den Ihrer Website",
  },
  appearance: {
    title: "Darstellung",
    buttonColor: "Farbe der Schaltfläche",
    background: "Hintergrund der Suchleiste",
    language: "Sprache",
  },
  preview: {
    title: "So sieht es auf einer Website aus",
    hint: "Eine Beispielseite mit Ihrer Suchleiste. Es ist das echte Widget: Wählen Sie Daten und tippen Sie auf Suchen, um zu sehen, wie es sich verhält.",
    openFull: "In voller Größe öffnen",
    testIn: "Testen auf",
    testInAriaLabel: "Beispielwebsite",
    missingUuid: "Die Kontokennung fehlt, um das Widget zu erzeugen.",
    fakeUrl: "ihre-website.com",
    iframeTitle: "Vorschau des Widgets auf einer Beispielwebsite",
  },
  guide: {
    title: "So binden Sie es auf Ihrer Website ein",
    hint: 'Funktioniert auf jeder Seite: HTML, WordPress (Block "Eigenes HTML"), Wix, Squarespace, Shopify… Nichts zu installieren.',
    warn: "<b>Wenn Ihre Website Wix, Squarespace oder Shopify ist</b>, zwei Dinge: Im <b>Editor</b> wirkt der Code-Block immer leer (er funktioniert nur in der \"Vorschau\" oder nach dem Veröffentlichen), und da diese Plattformen die Suchleiste in einen eigenen Rahmen setzen, <b>passiert alles innerhalb dieses Rahmens</b>: der Kalender und die Liste der Unterkünfte. <b>Ziehen Sie ihn daher auf etwa 900 px Höhe</b> im Editor; ist er zu niedrig, wird der Kalender abgeschnitten. Um den Rest kümmern wir uns: Ändern Sie den Code nicht.",
    missingUuid: "Die Kontokennung fehlt, um den Code zu erzeugen.",
    copy: "Kopieren",
    copied: "Kopiert",
    saveReload: "Speichern und Website neu laden",
  },
  steps: {
    script: {
      title: "Fügen Sie dies dort ein, wo die Suchleiste erscheinen soll",
      titleOwn: "Fügen Sie dies einmal an beliebiger Stelle der Seite ein",
      hint: "Genau dort, wo Sie die Datumsleiste möchten: im Hero, in einem Streifen unter dem Menü, in einer Seitenleiste…",
      hintOwn: "Es zeichnet nichts von selbst: Es bereitet die Buchung für Ihr eigenes Formular vor.",
      after: "Die Leiste behält eine feste Höhe und ändert ihre Größe nicht, sie bringt Ihr Layout also nicht durcheinander.",
    },
    target: {
      title: "Fügen Sie diesen Platzhalter dort ein, wo die Liste erscheinen soll",
      hint: 'Meist ein eigener Abschnitt unter dem Hero, mit Ihrer Überschrift darüber ("Verfügbarkeit", "Unsere Unterkünfte"…).',
      after: "Bis jemand sucht, nimmt dieser Platzhalter keinen Platz ein. Wenn Sie ihn weglassen, erscheint die Liste direkt unter der Suchleiste.",
    },
    api: {
      title: "Verbinden Sie Ihre Felder mit der Suche",
      hint: "Sie behalten Ihr Design, aber der Kalender kann unserer sein: der, der den Preis jeder Nacht, den Mindestaufenthalt und die belegten Tage anzeigt.",
      after: "Wenn Sie lieber eigene Datumsfelder nutzen, geht das auch: Übergeben Sie uns die Daten im Format YYYY-MM-DD direkt an WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Manuell kopieren",
    manualCopyDetail: "Ihr Browser hat das automatische Kopieren nicht zugelassen. Der Code ist bereits markiert.",
  },
};
